import { Ability } from '@casl/ability'
import { initialAbility } from './config'
const ability = JSON.parse(localStorage.getItem('ability'))
const existingAbility = ability ? ability : null

export default new Ability(existingAbility || initialAbility)
